import React from 'react';

const AdminSubscription = () => (
  <div className="admin-subscription">
    <h3>Subscription & Revenue</h3>
    <p>Create/update plans, view transactions — UI to be implemented.</p>
  </div>
);

export default AdminSubscription;
